import { isVariantSellable } from '@core/utils/variantSkus';

function hasEntries(value) {
  if (Array.isArray(value)) return value.length > 0;
  if (typeof value === 'number') return value > 0;
  if (typeof value === 'string') return value.trim() !== '' && value !== '0';
  return Boolean(value);
}

export function hasAlternativeUnitOptions(product) {
  const conversions =
    product?.alternative_units_and_conversions ?? product?.alternativeUnitsAndConversions;
  if (!Array.isArray(conversions)) return false;

  return conversions.some((conversion) => {
    const usage = conversion?.use_for ?? conversion?.useFor;
    if (!Array.isArray(usage)) return true;
    return usage.includes('SELLING');
  });
}

export function hasProductOptions(product) {
  if (!product || typeof product !== 'object') return false;
  // Sold per combination: always needs the picker, never a quick add.
  if (isVariantSellable(product)) return true;

  const recipeList = Array.isArray(product.recipe)
    ? product.recipe
    : Array.isArray(product.ingredients)
      ? product.ingredients
      : Array.isArray(product.recipe_details)
        ? product.recipe_details.flatMap((r) =>
            Array.isArray(r?.ingredients) ? r.ingredients : r?.ingredient_name ? [r] : [],
          )
        : Array.isArray(product.recipe_details?.ingredients)
          ? product.recipe_details.ingredients
          : [];

  const hasExcludableIngs =
    product.hasExcludableIngredients ||
    recipeList.some(
      (ing) =>
        ing?.is_excludable === true ||
        ing?.is_excludable === 'true' ||
        String(ing?.is_excludable).toLowerCase() === 'true',
    );

  const hasRecipeDetails =
    product.hasExcludableIngredients ||
    hasExcludableIngs ||
    (Array.isArray(product.recipe_details) && product.recipe_details.length > 0) ||
    Boolean(product.recipe_details);

  return (
    [
      product.hasOptions,
      product.hasVariants,
      product.hasModifiers,
      product.hasExcludableIngredients,
      hasExcludableIngs,
      hasRecipeDetails,
      product.variant_groups,
      product.variantGroups,
      product.single_variants,
      product.singleVariants,
      product.variants,
      product.variant_count,
      product.variantCount,
      product.has_variants,
      product.modifier_groups,
      product.modifierGroups,
      product.single_modifiers,
      product.singleModifiers,
      product.single_modifier_details,
      product.singleModifierDetails,
      product.modifiers,
      product.modifier_group_ids,
      product.modifierGroupIds,
      product.single_modifier_ids,
      product.singleModifierIds,
      product.modifier_count,
      product.modifierCount,
      product.has_modifiers,
      product.hasCombo,
      product.combo_groups,
      product.comboGroups,
      product.combo_group_details,
      product.comboGroupDetails,
      product.combo_count,
      product.comboCount,
      product.has_combo,
    ].some(hasEntries) || hasAlternativeUnitOptions(product)
  );
}
export function tracksOnlineInventory(entry) {
  if (!entry || typeof entry !== 'object') return false;
  const loc = Array.isArray(entry?.locations) ? entry.locations[0] : null;
  const source = loc?.online_track_inventory !== undefined ? loc : entry;
  return source?.online_track_inventory === true;
}

export function isSoldOutByOnlineInventory(entry) {
  if (!entry || typeof entry !== 'object') return false;
  const loc = Array.isArray(entry?.locations) ? entry.locations[0] : null;
  const availableQuantity = loc?.available_quantity ?? entry?.available_quantity ?? null;
  return (
    tracksOnlineInventory(entry) && availableQuantity !== null && Number(availableQuantity) <= 0
  );
}
